export default __webpack_public_path__ + "static/media/claps.32604d77.svg";